import { render, staticRenderFns } from "./pushChannel.vue?vue&type=template&id=0d124276&scoped=true"
import script from "./pushChannel.vue?vue&type=script&lang=js"
export * from "./pushChannel.vue?vue&type=script&lang=js"
import style0 from "./pushChannel.vue?vue&type=style&index=0&id=0d124276&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d124276",
  null
  
)

export default component.exports